import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import  departmentsService  from "../services/Departments.Service";
 

export const createDepartmentsDetails = createAsyncThunk("deparrtment/create",async (formData, thunkAPI)=>{
  try{
    const data =  await departmentsService.createBomUserDetails(formData);
    return data;
  }catch(err){
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  }
})
export const loadDepartments = createAsyncThunk("deparrtment/list", async (params, thunkAPI)=>{
  try{
    const response = await departmentsService.getDepartmentsList(params);
    return response.data
  }catch(err){
    if (!err.response) {
      return err
    }
    return thunkAPI.rejectWithValue(err?.response?.data)
  };
})

const initialState = {
  list:[],
  errors:false,
  success:false,
  loading:false,
  message:"",
  userBomData:[]
    
}

const DepartmentsSlice = createSlice({
  name : "departments",
  initialState,
  reducers:{
    reset:() => initialState,
  },
  extraReducers: {
    [createDepartmentsDetails.pending] : (state) => {
      state.loading = true
      state.errors = false
      state.success = false
    },
    [createDepartmentsDetails.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.errors = action.payload.message;    
      }else{
        state.success = action.payload.message; 
      } 
    },
    [createDepartmentsDetails.rejected] : (state, action) => {
      state.loading = false;
      state.errors = action.payload.error; 
    },
    // Featch Data
    [loadDepartments.rejected] : (state, action) => {
      state.loading = false
      state.error = action.payload.success;
      //k,nbbghjukklstate.message = action.

    },
    [loadDepartments.pending] : (state) => {
      state.loading = true
      state.error = false;
    },
    [loadDepartments.fulfilled] : (state, action) => {
      state.loading = false
      state.success = true;
      state.list = action.payload.docs
    }
    

  }
})


export const {reset} = DepartmentsSlice.actions
export default DepartmentsSlice.reducer